import { render, staticRenderFns } from "./integralManage.vue?vue&type=template&id=0ebbab48&"
import script from "./integralManage.vue?vue&type=script&lang=js&"
export * from "./integralManage.vue?vue&type=script&lang=js&"
import style0 from "./integralManage.vue?vue&type=style&index=0&id=0ebbab48&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports